import { getProp as s, normalizeValue as u } from "./utils.js";
import a from "lodash/isFunction";
import y from "lodash/isPlainObject";
function h(r, { value: t, type: i }) {
  return r == null ? !1 : (Array.isArray(t) || (t = [t]), i === "exact" ? t.some((e) => u(r) === u(e)) : t.some((e) => u(r).includes(u(e))));
}
function d(r, t) {
  return Array.isArray(r) || (r = [r]), (i, e) => r.some((o) => {
    const n = t.find((l) => l.property === o);
    let f = s(i, o);
    return n && n.formatter && (f = n.formatter(i, n)), y(f) && console.warn(
      `filtering entire objects is not supported. Please update filter prop ${o} to reference a specific key in the object.`
    ), h(f, e);
  });
}
function p(r) {
  return r.reduce((t, i) => {
    if (i.filters && i.filters.length) {
      const e = {
        prop: i.property,
        value: []
      };
      i.filters.forEach(({ checked: o, value: n }) => {
        o && e.value.push(n);
      }), e.value.length && (a(i.filterMethod) && (e.filterFn = i.filterMethod), t.push(e));
    }
    return t;
  }, []);
}
function m(r, t, i, e) {
  const o = (n, f) => {
    if (!f.isGroup && t(f, i))
      return n.push(f), n;
    if (e && Array.isArray(f[e.childKey])) {
      const l = f[e.childKey].reduce(o, []);
      l.length && n.push({ ...f, [e.childKey]: l });
    }
    return n;
  };
  return r.reduce(o, []);
}
function R({ rows: r, columns: t, globalFilters: i, options: e }) {
  const o = [...i, ...p(t)];
  return o.length > 0 && o.forEach((n) => {
    const { value: f, filterFn: l } = n;
    if (Array.isArray(f) && f.length === 0 || (f === void 0 || f === "") && !l)
      return !0;
    const c = l || d(n.prop, t);
    r = m(r, c, n, e);
  }), r;
}
export {
  m as applyFilterToRows,
  p as buildPerColumnFilters,
  d as createFilterFunction,
  h as filterCell,
  R as filterRows
};
//# sourceMappingURL=filter.js.map
